export default {
    typeOfPrice: '',
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(`update-price-selected?typeOfPrice=${this.typeOfPrice}`);
    },
    getMethod() {
        return 'PUT';
    },
    setTypeOfPrice(typeOfPrice) {
        this.typeOfPrice = typeOfPrice;
    },
    requestSuccess(data) {
        Odigeo.trigger('updatePriceSelectedOk', data);
        return data;
    },
    requestError(error) {
        Odigeo.trigger('updatePriceSelectedFail', error);
    },
};
